import { ZAttrValue } from "../../types/dataTypes";

export const getScalarValue = (
  aValue: ZAttrValue | null | undefined,
): boolean | number | string | null => {
  if (!aValue) return null;
  switch (aValue.type) {
    case "string":
    case "number":
    case "bool":
      return aValue.value;
    case "strOption":
      return aValue.value.value;
    default:
      break;
  }
  return null;
};
